import { BancoEmployee } from "banco/types/bancoEmployee";
import { PaymentUsageOption } from "./generated/constants";

export const LOAN_ACCOUNTS_STATUSES = {
  PENDING_SETUP: "pending_setup",
  PENDING_FUNDS_RELEASE: "pending_funds_release",
  OPEN: "open",
  CLOSED: "closed"
};

export const DISPLAY_DATETIME_FORMAT = "DD/MM/YYYY";

export const NEXT_DUE_DATE_CAVEAT =
  "Any adjustment to your account may take at least 24hrs to show on your online account.";

export const API_UNAVAILABLE_MESSAGE = "Not currently available, please try again later.";

export const SERVICERS = {
  EQUINITI: "equiniti",
  LINK: "link",
  TBI: "tbi",
  LANTERN: "lantern"
};

export enum API_STATUSES {
  LOADING = "loading",
  ERROR = "error",
  SUCCESS = "success",
  NONE = "none"
}

export const requestLoading = (requestState: API_STATUSES) => requestState === API_STATUSES.LOADING;
export const requestErrored = (requestState: API_STATUSES) => requestState === API_STATUSES.ERROR;
export const requestSucceeded = (requestState: API_STATUSES) => (
  requestState === API_STATUSES.SUCCESS
);

export enum ACTION_STATES {
  NONE = "none",
  FAILED = "failed",
  PENDING = "pending",
  SUCCEEDED = "succeeded"
}

export const BRAND_COLOURS = {
  GREEN_XD: "#015449",
  GREEN_D: "#077366",
  GREEN_M: "#0b8c79",
  GREEN_L: "#24a43d",
  GREEN_XL: "#e6f2f4",
  TEAL_M: "#03a8b5",
  WHITE: "#FFFFFF"
};

export enum Environment {
  DEVELOPMENT = "development",
  DUMMY = "dummy",
  NEXT = "next",
  PRELIVE = "prelive",
  PRODUCTION = "production"
}

export enum PaymentMethod {
  OneOff = "oneoff",
  ExistingCard = "existingCard",
  OpenBanking = "openBanking",
  AppleGooglePay = "appleGooglePay"
}

export const PaymentUsageOptionFriendlyNames: Record<PaymentUsageOption, string> = {
  [PaymentUsageOption.BLANK]: "",
  [PaymentUsageOption.PARTIAL_SETTLEMENT_TERM]: "Reduce your loan term",
  [PaymentUsageOption.PARTIAL_SETTLEMENT_INSTALMENT]: "Reduce your monthly payments",
  [PaymentUsageOption.PAYMENT_PLAN]: "Use towards a payment plan",
  [PaymentUsageOption.EXTRA_PAYMENT]: "Early payment",
  [PaymentUsageOption.TOWARDS_ARREARS]: "Use towards arrears"
};

export const MOCK_BANCO_EMPLOYEE: BancoEmployee = {
  email: "john.doe@bambooloans.com",
  first_name: "John",
  last_name: "Doe",
  display_name: "John Doe",
  username: "johndoe",
  urn: "urn:banco:banco_employee:FB123",
  database_authenticatable: true,
  telephony_provider: "talkdesk",
  roles: ""
};
